import React from 'react';
import formatRands from 'functions/formatRands.func';
import GetSvg from '../../vendor/GetSvg';

const getTotals = (stats) => [
  {
    icon: 'seal',
    value: stats.seals_unlocked,
    lines: ['Seals', 'Unlocked'],
  },
  {
    icon: 'sold',
    value: stats.items_sold,
    lines: ['Items', 'Sold'],
  },
  {
    icon: 'purchased',
    value: stats.items_purchased,
    lines: ['Total Items', 'Purchased'],
  },
  {
    icon: 'coupon_value',
    value: formatRands(stats.coupons_earned),
    lines: ['Coupons Earned'],
    isStacked: true,
  },
];

const LoyaltyTotals = ({ stats }) => (
  <div className="loyalty-totals">
    {getTotals(stats).map((total) => (
      <div
        className={`loyalty-totals__item${
          total.isStacked ? ' loyalty-totals__item--stacked' : ''
        }`}
        key={total.icon}>
        <GetSvg svg={total.icon} wrapperClass="svg loyalty-totals__icon" />
        <div className="loyalty-totals__text">
          <div className="loyalty-totals__value">{total.value}</div>
          <div className="loyalty-totals__label">
            {total.lines.map((line) => (
              <div className="loyalty-totals__label-line" key={line}>
                {line}
              </div>
            ))}
          </div>
        </div>
      </div>
    ))}
  </div>
);

export default LoyaltyTotals;
